import moment from 'moment-timezone'
import { DateTime } from '~/services/_utils/DateTime'
import { formats } from '~/const/global'

const dateTime = {
  computed: {
    yesterday () {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      return date.toISOString()
    },
    today () {
      const date = new Date()
      return date.toISOString()
    },
    nowDatetime () {
      const date = new Date()
      return moment(date).format(formats.dateTimeSec)
    }
  },
  methods: {
    toTime (date) {
      return DateTime.toTime(date)
    },
    formatTime (time) {
      if (!time) { return null }
      // TODO Временное решение
      return moment(new Date(time)).format(formats.dateTime)
    }
  }
}

export default dateTime
